// Dynamically import OneSignal to avoid loading it in the initial bundle
let OneSignalModule: typeof import("react-onesignal") | null = null;

const loadOneSignal = async () => {
  if (!OneSignalModule) {
    OneSignalModule = await import("react-onesignal");
  }
  return OneSignalModule.default;
};

export const initializeOneSignal = async () => {
  try {
    const OneSignal = await loadOneSignal();
    await OneSignal.init({
      appId: "1194850a-ad9e-497f-a7d2-1030a1308bce",
      allowLocalhostAsSecureOrigin: true,
    });

    if (process.env.NODE_ENV !== "production") {
      console.log("OneSignal initialized successfully");
    }
  } catch (error) {
    if (process.env.NODE_ENV !== "production") {
      console.error("OneSignal initialization error:", error);
    }
  }
};

export const requestNotificationPermission = async () => {
  try {
    const OneSignal = await loadOneSignal();
    const permission = await OneSignal.Notifications.requestPermission();
    if (process.env.NODE_ENV !== "production") {
      console.log("Notification permission:", permission);
    }
    return permission;
  } catch (error) {
    if (process.env.NODE_ENV !== "production") {
      console.error("Error requesting notification permission:", error);
    }
    return false;
  }
};

export const sendTestNotification = async (title: string, message: string) => {
  try {
    // This would be called from your backend
    if (process.env.NODE_ENV !== "production") {
      console.log("Test notification:", { title, message });
    }
  } catch (error) {
    if (process.env.NODE_ENV !== "production") {
      console.error("Error sending notification:", error);
    }
  }
};
